var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#DA322A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.365 15c-.265 0-.53-.111-.73-.333L.302 7.699C-.1 7.255-.1 6.536.303 6.091c.404-.445 1.057-.445 1.462 0l5.6 6.163c4.916-5.398 8.51-9.348 10.785-11.85.566-.624 1.205-.446 1.609 0 .404.444.255 1.147-.116 1.556L8.096 14.667c-.202.222-.466.333-.731.333z",
    transform: "translate(-336 -92) translate(336 92)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemCheck);
export default __webpack_public_path__ + "static/media/systemCheck.e55ec1fa.svg";
export { ForwardRef as ReactComponent };